import { PractitionerSearchResultApi } from './../../utils/interfaces/new/PractitionerSearchResultApi';
import { LogFonctionnelService } from '../log-fonctionnel/log-fonctionnel.service';
import { Injectable, ViewContainerRef } from '@angular/core';
import moment from 'moment';
import { EmailAuthent } from 'src/app/utils/interfaces/new/mss-email-authent.interface';
import { MSSFolderValidate } from 'src/app/utils/interfaces/new/mss-folder-validate.interface';
import { MSSFolder } from 'src/app/utils/interfaces/new/mss-folder.interface';
import { MSSMessageValidate } from 'src/app/utils/interfaces/new/mss-message-validate.interface';
import { MSSAddress, MSSAttachment, MSSEnumFlag, MSSEnumTypeMail, MSSMessage, MSSMessageToSend } from 'src/app/utils/interfaces/new/mss-message.interface';
import { MSSFullTextSearchCriteria, MSSSearchCriteria } from 'src/app/utils/interfaces/new/mss-search-criteria.interface';
import { MSSSyncMessagesResponse } from 'src/app/utils/interfaces/new/mss-sync-messages-response.interface';
import { PractitionerSearchResult } from 'src/app/utils/interfaces/new/PractitionerSearchResult';
import { MessageReleveTmp, MssServiceAbstract, PractitionerSearchParams, PractitionerSearchParamsAPICRYPT } from './mss-service.abstract';
import * as xmlParser from 'fast-xml-parser';
import { AnnuaireProfessionnelsSanteService } from '../annuaire-professionnels-sante/annuaire-professionnels-sante.service';
import { IdentifiantsTemporairesConnexion } from 'src/app/utils/interfaces/new/identifiantsTemporairesConnexion';
import { HttpClient } from '@angular/common/http';
import { FiltresService } from '../filtres/filtres.service';
import { InsRealservice } from '../ins/ins.service';

const MESSAGERIE_PATH = '/messagerie/';

const MSS_PATHS = {
  releverMessage: 'messages/relever',  // OK
};
@Injectable({
  providedIn: 'root'
})
export class MssMockService extends MssServiceAbstract {
  getMessageById(email: EmailAuthent, messageId: string): Promise<MSSMessage> {
    throw new Error('Method not implemented.');
  }
  canGetMessage(): boolean {
    throw new Error('Method not implemented.');
  }

  private _xmlMessageSample = `
  <soap11:Envelope xmlns:soap11="http://schemas.xmlsoap.org/soap/envelope/">
  <soap11:Header>
    <ecp:Response xmlns:ecp="urn:oasis:names:tc:SAML:2.0:profiles:SSO:ecp"></ecp:Response>
  </soap11:Header>
  <soap11:Body>
    <MessageId>987654321</MessageId>
    <Date>2021-01-08T13:22:26.542Z</Date>
    <Size>32</Size>
    <Flags>UNREAD</Flags>
    <Flags>FORWARDED</Flags>
    <FolderId>456789123</FolderId>
    <OrigId>321654987</OrigId>
    <Addresses>
      <Email>toto@test.fr</Email>
      <Type>TO</Type>
    </Addresses>
    <Addresses>
      <Email>titi@test.fr</Email>
      <Type>TO</Type>
    </Addresses>
    <Addresses>
      <Email>tata@test.fr</Email>
      <Type>FROM</Type>
      <Name>Tata Ginette</Name>
    </Addresses>
    <IsBodyLarger>false</IsBodyLarger>
    <Subject>Objet de mon mail</Subject>
    <Fragment>kesese</Fragment>
    <Body>Voici le contenu de mon mail</Body>
    <Attachments>
      <Part>2</Part>
      <ContentType>image/png</ContentType>
      <FileName>picture.png</FileName>
      <MessageId>987654321</MessageId>
    </Attachments>
    <Attachments>
      <Part>1</Part>
      <ContentType>image/png</ContentType>
      <FileName>picture2.png</FileName>
      <MessageId>987654321</MessageId>
    </Attachments>
    <Attachments>
      <Part>5</Part>
      <ContentType>image/png</ContentType>
      <FileName>toto.png</FileName>
      <MessageId>987654321</MessageId>
    </Attachments>
    <Attachments>
      <Part>6</Part>
      <ContentType>image/png</ContentType>
      <FileName>test.png</FileName>
      <MessageId>987654321</MessageId>
    </Attachments>
  </soap11:Body>
</soap11:Envelope>
  `;

  private _xmlFolderSample = `
  <soap11:Envelope xmlns:soap11="http://schemas.xmlsoap.org/soap/envelope/">
  <soap11:Header>
    <ecp:Response xmlns:ecp="urn:oasis:names:tc:SAML:2.0:profiles:SSO:ecp"></ecp:Response>
  </soap11:Header>
  <soap11:Body>
    <FolderId>345678912</FolderId>
    <FolderName>Archivés</FolderName>
    <FolderNbUnread>15</FolderNbUnread>
    <folders>
      <FolderId>567891234</FolderId>
      <FolderName>À supprimer</FolderName>
      <FolderNbUnread>0</FolderNbUnread>
    </folders>
    <folders>
      <FolderId>678912345</FolderId>
      <FolderName>Urgents</FolderName>
      <FolderNbUnread>6</FolderNbUnread>
    </folders>
    <folders>
      <FolderId>789123456</FolderId>
      <FolderName>Internes cabinet</FolderName>
      <FolderNbUnread>2</FolderNbUnread>
    </folders>
  </soap11:Body>
</soap11:Envelope>
  `;

  private _xmlFolderSample2 = `
  <soap11:Envelope xmlns:soap11="http://schemas.xmlsoap.org/soap/envelope/">
  <soap11:Header>
    <ecp:Response xmlns:ecp="urn:oasis:names:tc:SAML:2.0:profiles:SSO:ecp"></ecp:Response>
  </soap11:Header>
  <soap11:Body>
    <FolderId>456789123</FolderId>
    <FolderName>Corbeille</FolderName>
    <FolderNbUnread>0</FolderNbUnread>
  </soap11:Body>
</soap11:Envelope>
  `;

  private _mockFolder1: MSSFolder = {
    folderId: 123456789, folderName: 'Boîte de réception', folderNbUnread: 15, folders: []
  };

  private _mockFolder2: MSSFolder = {
    folderId: 234567891, folderName: 'Messages envoyés', folderNbUnread: 2, folders: []
  };

  private _mockFolder3: MSSFolder = {
    folderId: 345678912, folderName: 'Archivés', folderNbUnread: 0, folders: []
  };

  private _mockFolder4: MSSFolder = {
    folderId: 456789123, folderName: 'Corbeille', folderNbUnread: 1459, folders: []
  };

  private _mockFolder31: MSSFolder = {
    folderId: 567891234, folderName: 'À supprimer', folderNbUnread: 0, folders: []
  };

  private _mockFolder32: MSSFolder = {
    folderId: 678912345, folderName: 'Urgents', folderNbUnread: 6, folders: []
  };

  private _mockFolder33: MSSFolder = {
    folderId: 789123456, folderName: 'Internes cabinet', folderNbUnread: 2, folders: []
  };

  private _mockMessage1: MSSMessage = {
    date: moment(new Date()).subtract(4, 'days').toDate(),
    folderId: 456789123,
    messageId: 987654321,
    size: 2000,
    subject: 'Mon premier message',
    body: 'Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??',
    addresses: [{
      email: 'Géraldine@titi.fr',
      type: MSSEnumTypeMail.FROM,
      name: 'Géraldine'
    }],
    flags: [MSSEnumFlag.UNREAD]
  };

  private _mockMessage2: MSSMessage = {
    date: moment(new Date()).subtract(2, 'days').toDate(),
    folderId: 456789123,
    messageId: 876543219,
    size: 2000,
    subject: 'Mon deuxième message',
    body: 'Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??Voici le body de mon premier message. C\'est t\'y pas swag ??',
    addresses: [{
      email: 'toto@titi.fr',
      type: MSSEnumTypeMail.FROM
    }, {
      email: 'tutu@titi.fr',
      name: 'TUTU test',
      type: MSSEnumTypeMail.TO
    }, {
      email: 'tata@titi.fr',
      type: MSSEnumTypeMail.CC
    }, {
      email: 'tata@titi.fr',
      type: MSSEnumTypeMail.TO
    }, {
      email: 'tata@titi.fr',
      type: MSSEnumTypeMail.BCC
    }, {
      email: 'tata@titi.fr',
      type: MSSEnumTypeMail.BCC
    }],
    attachments: [{
      contentType: 'image/png',
      fileName: 'Toto.png',
      part: 1
    }, {
      contentType: 'image/png',
      fileName: 'Titi.png',
      part: 2
    }, {
      contentType: 'image/png',
      fileName: 'Toto.png',
      part: 3
    }, {
      contentType: 'image/png',
      fileName: 'Toto.png',
      part: 4
    }, {
      contentType: 'image/png',
      fileName: 'Tutu.png',
      part: 5
    }, {
      contentType: 'image/png',
      fileName: 'Toto.png',
      part: 6
    }, {
      contentType: 'image/png',
      fileName: 'Toto.png',
      part: 7
    }, {
      contentType: 'image/png',
      fileName: 'Toto.png',
      part: 8
    }]
  };

  private _mockMessage3: MSSMessage = {
    date: new Date(),
    folderId: 123456789,
    messageId: 765432198,
    size: 2000,
    subject: 'Mon troisième message',
    body: 'Voici le body de mon troisième message. Définitivement c\'est swag :D',
    addresses: [{
      email: 'tutu@titi.fr',
      type: MSSEnumTypeMail.FROM
    }]
  };

  private _mockMessage4: MSSMessage = {
    date: moment(new Date()).subtract(1, 'days').toDate(),
    folderId: 456789123,
    messageId: 654321987,
    size: 2000,
    subject: 'Mon premier brouillon',
    body: 'Ceci est message en cours de réda...',
    flags: [MSSEnumFlag.DRAFT],
    attachments: [{
      contentType: 'image/png',
      fileName: 'Toto.png',
      part: 1
    }, {
      contentType: 'image/png',
      fileName: 'Toto.png',
      part: 2
    }]
  };

  private _mockFile1 = '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';
  private _mockFile2 = 'iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAIAAADTED8xAAADMElEQVR4nOzVwQnAIBQFQYXff81RUkQCOyDj1YOPnbXWPmeTRef+/3O/OyBjzh3CD95BfqICMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMO0TAAD//2Anhf4QtqobAAAAAElFTkSuQmCC';
  private _mockFile3 = 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg==';
  private _mockFile4 = 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mPkm2hRDwAC5AFYpMcO5wAAAABJRU5ErkJggg==';
  private _mockFile5 = 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mO08NatBwACpAExC+DVvwAAAABJRU5ErkJggg==';
  private _mockFile6 = 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mO0mPi/HgAFGgJJ89sZvQAAAABJRU5ErkJggg==';
  private _mockFile7 = 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8OvF/PQAIDgMG8LO5igAAAABJRU5ErkJggg==';
  private _mockFile8 = 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mPcxS9QDwADvgFa18U7oAAAAABJRU5ErkJggg==';

  constructor(
    protected _http: HttpClient,
    private _apsService: AnnuaireProfessionnelsSanteService,
    protected _filtreSrv: FiltresService,
    protected _logSrv: LogFonctionnelService
    ) {
      super(_http, _filtreSrv, _logSrv);
  }


  canCreateFolders(): boolean {
    return false;
  }

  canRenameFolders(): boolean {
    return false;
  }

  canRemoveFolders(): boolean {
    return false;
  }

  canListFolders(): boolean {
    return false;
  }

  canMoveMessages(): boolean {
    return false;
  }
  canSyncMessages(): boolean {
    return false;
  }

  canRemoveAttachment(): boolean {
    return false;
  }

  canDraftMessage(): boolean {
    return false;
  }

  canMarkMessageAsRead(): boolean {
    return false;
  }

  isTokenNeeded(): boolean {
    return false;
  }

  isOTPNeeded(): boolean {
    return false;
  }

  isSearchMessageHandlePagination(): boolean {
    return false;
  }
  mustDraftToAddAttachment(): boolean {
    return false;
  }
  providerLibellePrefix(): string {
    return 'Mock';
  }
  isSessionValid(email: EmailAuthent): Promise<boolean> {
    return new Promise(resolve => resolve(true));
  }
  removeAttachment(email: EmailAuthent, messageId: number, attachment: MSSAttachment): Promise<void> {
    throw new Error('Method not implemented.');
  }
  clearToken(idNat: string): void {
    throw new Error('Method not implemented.');
  }
  listAccounts(): Promise<string[]> {
    throw new Error('Method not implemented.');
  }
  storeToken(token: string, idNat: string): void  {
    throw new Error('Method not implemented.');
  }
  validateOTP(otp: string, identifiants: IdentifiantsTemporairesConnexion): Promise<void>  {
    throw new Error('Method not implemented.');
  }

  private _getMockFileBase64(filePart: number): string {
    if (filePart === 1) {
      return this._mockFile1;
    } else if (filePart === 2) {
      return this._mockFile2;
    } else if (filePart === 3) {
      return this._mockFile3;
    } else if (filePart === 4) {
      return this._mockFile4;
    } else if (filePart === 5) {
      return this._mockFile5;
    } else if (filePart === 6) {
      return this._mockFile6;
    } else if (filePart === 7) {
      return this._mockFile7;
    } else if (filePart === 8) {
      return this._mockFile8;
    }
  }

  private _getFolders(): Array<MSSFolder> {
    const rtd = this._xmlFolderToMSSFolder(this._xmlFolderSample);
    const rtd2 = this._xmlFolderToMSSFolder(this._xmlFolderSample2);
    return [rtd, rtd2];
    // this._mockFolder3.folders = [this._mockFolder31, this._mockFolder32, this._mockFolder33];

    // return [
    //   this._mockFolder1,
    //   this._mockFolder2,
    //   this._mockFolder3,
    //   this._mockFolder4
    // ];

    // this._mockFolder3.folders = [this._mockFolder31, this._mockFolder32, this._mockFolder33];
    // this._mockFolder4.folders = [this._mockFolder3];

    // return [
    //   this._mockFolder1,
    //   this._mockFolder2,
    //   this._mockFolder4
    // ];
  }

  private _getFolder(folderId: number): MSSFolder | undefined {
    // const folders = [
    //   this._mockFolder1,
    //   this._mockFolder2,
    //   this._mockFolder3,
    //   this._mockFolder4,
    //   this._mockFolder31,
    //   this._mockFolder32,
    //   this._mockFolder33
    // ];

    const folders = [
      this._xmlFolderToMSSFolder(this._xmlFolderSample),
      this._xmlFolderToMSSFolder(this._xmlFolderSample2)
    ];

    for (const folder of folders) {
      if (folder.folderId === folderId) {
        return folder;
      }
    }

    return undefined;
  }

  private async _getMessages(): Promise<Array<MSSMessage>>{

    // return [this._mockMessage1, this._mockMessage2, this._mockMessage3, this._mockMessage4];
    const rtd1 = this._xmlMsgToMSSMessage(this._xmlMessageSample);

    if (rtd1.attachments) {
      for (const a of rtd1.attachments) {
        a.file = this._mockFile1;
      }
    }

    return [
      rtd1
    ];
  }

  public async listFolders(email: EmailAuthent, folderId?: number): Promise<Array<MSSFolder>> {
    return new Promise<Array<MSSFolder>>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        if (folderId) {
          const folder = this._getFolder(folderId);

          if (!folder) {
            throw new Error('Aucun dossier trouvé');
          }
        } else {
          resolve(this._getFolders());
        }
      } catch (e) {
        reject({
          message: 'Une erreur est survenue lors de la récupération des dossiers de la messagerie'
        });
      }
    });
  }

  public async createFolder(email: EmailAuthent, folderName: string, folderParentId: number): Promise<MSSFolderValidate> {
    return new Promise<MSSFolderValidate>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        // On vérifie que le dosier parent existe
        const parentFolder = this._getFolder(folderParentId);
        if (!parentFolder)  {
          throw new Error('Le dossier parent n’existe pas');
        }

        // On vérifie qu'un dossier au même niveau avec le même nom n'existe pas déjà
        for (const folder of parentFolder.folders) {
          if (folder.folderName === folderName) {
            throw new Error('Un dossier de même niveau existe déjà avec le même nom');
          }
        }

        resolve({
          folderId: Math.trunc(Math.random() * 999999999),
          folderName
        });

      } catch (e) {
        reject({
          message: 'Une erreur est survenue lors de la création du dossier'
        });
      }
    });
  }

  public async trashFolder(email: EmailAuthent, folderId: number): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        // On vérifie que le dosier parent existe
        const parentFolder = this._getFolder(folderId);
        if (!parentFolder)  {
          throw new Error('Le dossier n’existe pas');
        }

        resolve();
      } catch (e) {
        reject({
          message: 'Une erreur est survenue lors de la suppression du dossier'
        });
      }
    });
  }

  public async renameFolder(email: EmailAuthent, folderId: number, newFolderName: string): Promise<void>{
    return new Promise<void>(async (resolve, reject) => {
      try {
        // On vérifie que le dosier parent existe
        const parentFolder = this._getFolder(folderId);
        if (!parentFolder)  {
          throw new Error('Le dossier n’existe pas');
        }

        resolve();
      } catch (e) {
        reject({
          message: 'Une erreur est survenue lors du renommage du dossier'
        });
      }
    });
  }

  public async searchMessages(email: EmailAuthent, searchCriteria: MSSSearchCriteria): Promise<Array<MSSMessage>>{
    return new Promise<Array<MSSMessage>>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        const messages = await this._getMessages();

        let rtd: Array<MSSMessage> = [];
        for (const m of messages) {
          if (m.folderId === searchCriteria.query.folderId) {
            rtd.push(m);
          }
        }

        if (searchCriteria.limit && searchCriteria.offset && searchCriteria.limit <= rtd.length) {
          rtd = rtd.splice((searchCriteria.offset - 1) * searchCriteria.limit, searchCriteria.limit);
        }

        resolve(rtd);
      } catch (e) {
        reject({
          message: 'Une erreur est survenue lors de la recherche des messages'
        });
      }
    });
  }

  public async moveMessages(email: EmailAuthent, messageIds: Array<number>, destinationFolderId: number): Promise<void>{
    return new Promise<void>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        resolve();
      } catch (e) {
        reject({
          message: 'Une erreur est survenue lors du déplacement du message'
        });
      }
    });
  }

  public async syncMessages(email: EmailAuthent, folderId?: number, syncToken?: string): Promise<MSSSyncMessagesResponse>{
    return new Promise<MSSSyncMessagesResponse>(async (resolve, reject) => {
      try {
        await this._fakeAwait();

        resolve({
          deletedMessageIds: [],
          modifiedMessages: [
            this._xmlMsgToMSSMessage(this._xmlMessageSample)
          ],
          token: '5647382910'
        });
      } catch (e) {
        reject({
          message: 'Une erreur est survenue lors de la synchronisation des message'
        });
      }
    });
  }

  public async downloadAttachment(email: EmailAuthent, messageId: number, attachment: MSSAttachment): Promise<{file: File, base64: string}>{
    const urltoFile = async (url, filename, mimeType): Promise<File> => {
      return new Promise<File>((resolve) => {
        fetch(url).then((res) => {
          return res.arrayBuffer();
        }).then((buf) => {
          resolve(new File([buf], filename, { type: mimeType }));
        });
      });
    };

    return new Promise<{file: File, base64: string}>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        const base64 = await this._getMockFileBase64(attachment.part);
        const file = await urltoFile(base64, attachment.fileName, attachment.contentType);
        resolve({
          file,
          base64
        });
      } catch (e) {
        reject({
          message: 'Une erreur est survenue lors du téléchargement de la pièce-jointe'
        });
      }
    });
  }

  public async deleteMessage(email: EmailAuthent, messageId: number | Array<number>): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        resolve();
      } catch (e) {
        reject({
          message: 'Une erreur est survenue lors de la suppression du message'
        });
      }
    });
  }

  public async draftMessage(email: EmailAuthent, messages: MSSMessageToSend): Promise<MSSMessageValidate | undefined> {
    return new Promise<MSSMessageValidate | undefined>(async (resolve, reject) => {
      try {
        console.log('MESSAGES : ', messages);
        await this._fakeAwait();
        resolve(undefined);
      } catch (e) {
        reject({
          message: 'Une erreur est survenue lors de l\'enregistrement du message'
        });
      }
    });
  }

  public async sendMessage(email: EmailAuthent, messages: MSSMessageToSend): Promise<MSSMessageValidate | undefined> {
    return new Promise<MSSMessageValidate | undefined>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        resolve(undefined);
      } catch (e) {
        reject({
          message: 'Une erreur est survenue lors de l\'envoi du message'
        });
      }
    });
  }

  public async markMessageAsRead(email: EmailAuthent, messageId: number | Array<number>): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        resolve();
      } catch (e) {
        reject({
          message: 'Une erreur est survenue lors de la modification du message'
        });
      }
    });
  }

  public async fullTextSearchMessages(email: EmailAuthent, searchCriteria: MSSFullTextSearchCriteria): Promise<Array<MSSMessage>>{
    return new Promise<Array<MSSMessage>>(async (resolve, reject) => {
      try {
        await this._fakeAwait(1000);

        const rtd: Array<MSSMessage> = [];
        const messages = await this._getMessages();
        for (const m of messages) {
          if (m.body) {
            m.body = m.body.toLowerCase();
          }

          m.subject = m.subject.toLowerCase();

          if ((m.body && m.body.includes(searchCriteria.query.searchString.toLowerCase()))
            || m.subject.includes(searchCriteria.query.searchString.toLowerCase())) {
            rtd.push(m);
          }
        }

        resolve(rtd);
      } catch (e) {
        reject({
          message: 'Une erreur est survenue lors de la recherche de messages'
        });
      }
    });
  }

  public async findMSSRecipient(params: PractitionerSearchParams, limit = 10, offset = 0,
                                doForceSearch = false): Promise<PractitionerSearchResult>{
    return new Promise<PractitionerSearchResult>(async (resolve, reject) => {
      try {
        resolve(await this._apsService.searchProfessionals(params, limit, offset, doForceSearch));
      } catch (e) {
        reject(e);
      }
    });
  }

  public async findMSSRecipientApi(params: PractitionerSearchParamsAPICRYPT, limit = 10, offset = 0,
                                doForceSearch = false): Promise<PractitionerSearchResultApi>{
    return new Promise<PractitionerSearchResultApi>(async (resolve, reject) => {
      try {
        resolve(await this._apsService.searchProfessionalsApi(params, limit, offset, doForceSearch));
      } catch (e) {
        reject(e);
      }
    });
  }

  private _xmlFolderToMSSFolder(xmlStr: string): MSSFolder {
    const xmlFolderToMSSFolder = (xmlFolder: any): MSSFolder => {
      const foldersArray: Array<MSSFolder> = [];
      if (xmlFolder.folders && xmlFolder.folders.length > 0) {
        for (const f of xmlFolder.folders) {
          foldersArray.push(xmlFolderToMSSFolder(f));
        }
      }

      return {
        folderId: xmlFolder.FolderId,
        folderName: xmlFolder.FolderName,
        folderNbUnread: xmlFolder.FolderNbUnread,
        folders: foldersArray
      };
    };

    const options = {
      ignoreNameSpace: true,
      ignoreAttributes: true
    };

    const xmlObj = xmlParser.parse(xmlStr, options).Envelope.Body;

    const folders: Array<MSSFolder> = [];

    if (xmlObj.folders && xmlObj.folders.length > 0) {
      for (const f of xmlObj.folders) {
        folders.push(xmlFolderToMSSFolder(f));
      }
    }

    return {
      folderId: xmlObj.FolderId,
      folderName: xmlObj.FolderName,
      folderNbUnread: xmlObj.FolderNbUnread,
      folders
    };
  }

  private _xmlMsgToMSSMessage(xmlStr: string): MSSMessage {
    const xmlAddressToMSSAddress = (xmlAddress: any): MSSAddress => {
      return {
        email: xmlAddress.Email,
        type: xmlAddress.Type,
        name: xmlAddress.Name ? xmlAddress.Name : undefined
      };
    };

    const xmlFlagToMSSFlag = (xmlFlag: any): MSSEnumFlag => {
      if (xmlFlag === 'UNREAD') {
        return MSSEnumFlag.UNREAD;
      } else if (xmlFlag === 'FLAGGED') {
        return MSSEnumFlag.FLAGGED;
      } else if (xmlFlag === 'ATTACHMENT') {
        return MSSEnumFlag.ATTACHMENT;
      } else if (xmlFlag === 'REPLIED') {
        return MSSEnumFlag.REPLIED;
      } else if (xmlFlag === 'SENT_BY_ME') {
        return MSSEnumFlag.SENT_BY_ME;
      } else if (xmlFlag === 'DELETED') {
        return MSSEnumFlag.DELETED;
      } else if (xmlFlag === 'DRAFT') {
        return MSSEnumFlag.DRAFT;
      } else if (xmlFlag === 'FORWARDED') {
        return MSSEnumFlag.FORWARDED;
      } else if (xmlFlag === 'URGENT') {
        return MSSEnumFlag.URGENT;
      } else if (xmlFlag === 'LOW_PRIORITY') {
        return MSSEnumFlag.LOW_PRIORITY;
      } else if (xmlFlag === 'PRIORITY') {
        return MSSEnumFlag.PRIORITY;
      }
    };

    const xmlAttachmentToMSSAttachment = (attachment: any): MSSAttachment => {
      return {
        contentType: attachment.ContentType,
        fileName: attachment.FileName,
        messageId: attachment.MessageId,
        part: attachment.Part
      };
    };

    const options = {
      ignoreNameSpace: true,
      ignoreAttributes: true
    };

    const xmlObj = xmlParser.parse(xmlStr, options).Envelope.Body;

    const addresses: Array<MSSAddress> = [];
    const flags: Array<MSSEnumFlag> = [];
    const attachments: Array<MSSAttachment> = [];

    if (xmlObj.Addresses && xmlObj.Addresses.length > 0) {
      for (const a of xmlObj.Addresses) {
        addresses.push(xmlAddressToMSSAddress(a));
      }
    }

    if (xmlObj.Flags && xmlObj.Flags.length > 0) {
      for (const f of xmlObj.Flags) {
        flags.push(xmlFlagToMSSFlag(f));
      }
    }

    if (xmlObj.Attachments && xmlObj.Attachments.length > 0) {
      for (const f of xmlObj.Attachments) {
        attachments.push(xmlAttachmentToMSSAttachment(f));
      }
    }

    return {
      addresses,
      flags,
      attachments,
      date: xmlObj.Date,
      folderId: xmlObj.FolderId,
      messageId: xmlObj.MessageId,
      size: xmlObj.Size,
      subject: xmlObj.Subject,
      body: xmlObj.Body,
      fragment: xmlObj.Fragment,
      isBodyLarger: xmlObj.IsBodyLarger,
      origId: xmlObj.OrigId
    };
  }

  public async connectToMSSByIDNAT(mail: string, password: string): Promise<any> {
    return new Promise<any>(async (resolve, reject) => {
      try {
        await this._fakeAwait();
        resolve({});
      } catch (e) {
        reject(e);
      }
    });
  }

  // TODO À retirer lors du demokage
  private async _fakeAwait(lenght = 500): Promise<void> {
    return new Promise<void>((resolve) => {
      setTimeout(() => {
        resolve();
      }, lenght);
    });
  }

  sauvegarderCourrierReleve(message: MSSMessage, testInsiTools?: { insSrv: InsRealservice, view: ViewContainerRef }): Promise<MessageReleveTmp> {
    throw new Error('Method not implemented.');
  }
}
